var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburgerMenu = function SvgHamburgerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "top-line",
    x: 10,
    y: 12,
    width: 30,
    height: 4,
    rx: 3,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "middle-line",
    x: 10,
    y: 22,
    width: 30,
    height: 4,
    rx: 3,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "bottom-line",
    x: 10,
    y: 32,
    width: 30,
    height: 4,
    rx: 3,
    fill: "currentColor"
  })));
};
export default SvgHamburgerMenu;